var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDiscordPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#0222ba}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(-131 -960)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    transform: "translate(131 960)",
    style: {
      fill: "none",
      opacity: 0.502
    },
    d: "M0 0h24v24H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discord_1_",
    "data-name": "discord (1)",
    transform: "translate(132.833 962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    className: "cls-2",
    d: "M3.15 17.663h11.883l-.567-1.838 1.358 1.165 1.244 1.115L19.333 20V2.063A2.212 2.212 0 0 0 17.127 0H3.154A2.127 2.127 0 0 0 1 2.067V15.6a2.085 2.085 0 0 0 2.15 2.063zm8.79-12.927-.027.01.01-.01zM5.581 5.793a5.141 5.141 0 0 1 2.943-1.058l.114.112a6.066 6.066 0 0 0-2.716 1.281s.227-.111.622-.28a9.516 9.516 0 0 1 7.812.335 6.854 6.854 0 0 0-2.6-1.281l.155-.153a5.146 5.146 0 0 1 2.9 1.05 12.864 12.864 0 0 1 1.537 5.85 4.441 4.441 0 0 1-3.276 1.438s-.393-.445-.673-.833a3.366 3.366 0 0 0 1.867-1.17 12.263 12.263 0 0 1-1.182.614 7.913 7.913 0 0 1-1.523.446 8.107 8.107 0 0 1-5.027-.78l-.436-.222A3.345 3.345 0 0 0 7.9 12.313c-.343.391-.682.835-.682.835a3.706 3.706 0 0 1-3.168-1.505 12.9 12.9 0 0 1 1.528-5.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    className: "cls-2",
    d: "M14.308 12.771a1.338 1.338 0 0 0 0-2.675 1.337 1.337 0 0 0 0 2.672z",
    transform: "translate(-2.269 -1.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    className: "cls-2",
    d: "M9.69 12.771a1.338 1.338 0 0 0 0-2.675 1.337 1.337 0 0 0 0 2.672z",
    transform: "translate(-1.397 -1.894)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscordPrimary);
export default __webpack_public_path__ + "static/media/icon-discord-primary.9b5af7f28a23930ad9df8e8988e0866e.svg";
export { ForwardRef as ReactComponent };